const breakPoint = 767;
let resizeFlag   = false;
let windowWidth  = window.innerWidth;
let windowHeight = window.innerHeight;
let windowWidthJ = $(window).width();


const getCookie = () => {
  var arr = new Array();
  if (document.cookie != '') {
    var tmp = document.cookie.split('; ');
    for (var i = 0; i < tmp.length; i++) {
      var data = tmp[i].split('=');
      arr[data[0]] = decodeURIComponent(data[1]);
    }
  }
  return arr;
};


function videoControl(action, target) {
  var $playerWindow = $(target)[0].contentWindow;
  $playerWindow.postMessage('{"event":"command","func":"' + action + '","args":""}', '*');
}

// preload
const preload = () => {
  $(window).on("load", function () {
    $("body").removeClass("preload");
  });
};

// ------------------------------------------------------------------------
// anchorLink
// ------------------------------------------------------------------------
const anchorLink = () => {
  $("a[href^='#']").on("click", function () {
    var linkSpeed = 800;
    var linkHref = $(this).attr("href");
    var linkAdjust = 0;
    if (linkHref == "#" || linkHref == "") {
      var linkTarget = $(linkHref == "#" || linkHref == "" ? 'html' : linkHref);
      var linkPosition = linkTarget.offset().top;
    } else {
      var linkPosition = document.querySelector(linkHref).offsetTop;
    }
    $("html, body").animate({ scrollTop: linkPosition - linkAdjust }, linkSpeed, "swing");
    return false;
  });
};



// ------------------------------------------------------------------------
// topSlider
// ------------------------------------------------------------------------
const topSlider = () => {
  $(function () {
    const targetElm = $(".op-list_current");

    let swiper = new Swiper('.op-wrapper', {
      speed: 600,
      threshold: 10,
      touchRatio: 0.9,
      slidesPerView: 'auto',
      autoHeight: false,
      navigation: {
        nextEl: '.op-list_next',
        prevEl: '.op-list_prev',
      },
      loop: true,
      on: {
        init: function () {
          targetElm.text("01");
        },
      }
    });

    swiper.on('transitionStart', function () {
      targetElm.addClass("progress");
    });
    swiper.on('transitionEnd', function () {
      let currentIdx = swiper.realIndex + 1;
      targetElm.text(("0" + currentIdx).slice(-2));
      targetElm.removeClass("progress");
    });
  });
};


// ------------------------------------------------------------------------
// middleSlider
// ------------------------------------------------------------------------
const middleSlider = () => {
  $(function () {

    let swiper = new Swiper('.ac-wrapper', {
      speed: 600,
      threshold: 10,
      touchRatio: 0.9,
      slidesPerView: 'auto',
      centeredSlides: true,
      autoHeight: false,
      navigation: {
        nextEl: '.ac-list_next',
        prevEl: '.ac-list_prev',
      },
      loop: true,
      pagination: {
        el: '.ac-list_pager',
        clickable: true,
        renderBullet: function (index, className) {
          // 下のサムネイルブロックを出力
          // let targetImage = swiper.slides[index].attr('data-profile');
          let targetImage = this.slides[index].dataset.profile;
          // console.log(targetImage)
          return '<div class="' + className + '"><div class="swiper-pagination-bullet-image" style="background:url(./assets/images/common/profile/' + targetImage + ') no-repeat;background-size:cover;background-position:center;">' + '</div></div>';
        },
      },
    });
  });
};



// ------------------------------------------------------------------------
// toggleNav
// ------------------------------------------------------------------------
const toggleNav = () => {
  $(".header-hamburger_button , .header-anchor").on("click", function () {
    if ($(".st-Profile").hasClass("open")){
      $(".st-Profile").toggleClass("open");
      $(".header-hamburger_button").toggleClass("open-profile");
      $(".header-hamburger_button").toggleClass("open");
      $(".header-hamburger").toggleClass("open");
      setTimeout(function () {
        $(".profile-wrapper").removeClass("visible");
      }, 300);
    } else if ($(".st-Movie").hasClass("open")) {
      $(".st-Movie").toggleClass("open");
      $(".header-hamburger_button").toggleClass("open-movie");
      $(".header-hamburger_button").toggleClass("open");
      $(".header-hamburger").toggleClass("open");
      videoControl("stopVideo", '#youtube-modal');
    } else {
      $(".header-hamburger_button").toggleClass("open");
      $(".header-hamburger").toggleClass("open");
      $(".header-nav").toggleClass("open");
    }
  });
};



// ------------------------------------------------------------------------
// toggleProf
// ------------------------------------------------------------------------
const toggleProf = () => {
  $(window).on("load", function () {
    $(".item-profile_toggle").on("click", function () {
      let profileId = "#profile-" + $(this).data("number");
      // console.log(profileId);
      $(".st-Profile").toggleClass("open");
      $(profileId).toggleClass("visible");
      $(".header-hamburger_button").toggleClass("open-profile");
      $(".header-hamburger_button").toggleClass("open");
      $(".header-hamburger").toggleClass("open");
    });
  });


};



// ------------------------------------------------------------------------
// toggleMovie
// ------------------------------------------------------------------------
const toggleMovie = () => {
  const ua = navigator.userAgent;
  $(".st-Movie_Toggle").on("click", function () {
    let youtubeId = $(this).data("movie");
    let embedUrl = "https://www.youtube.com/embed/" + youtubeId + "?autoplay=1&mute=1&enablejsapi=1";
    $(".st-Movie").toggleClass("open");
    $(".header-hamburger_button").toggleClass("open-movie");
    $(".header-hamburger_button").toggleClass("open");
    $(".header-hamburger").toggleClass("open");
    $('#youtube-modal').attr( "src", embedUrl);
    $('#youtube-modal').on('load', function () {
      videoControl("playVideo", '#youtube-modal');
      if (/android/i.test(ua)){
        videoControl("unMute", '#youtube-modal');
      }
    });
  });
};


// ------------------------------------------------------------------------
// loading
// ------------------------------------------------------------------------
const loading = () => {
  $(window).on("load", function () {
    // let embedUrl = "https://www.youtube.com/embed/Dm2O_W6Rrss?autoplay=1&mute=1&enablejsapi=1";
    // $(".st-Movie").toggleClass("open");
    // $(".header-hamburger_button").toggleClass("open-movie");
    // $(".header-hamburger_button").toggleClass("open");
    // $('#youtube-modal').attr("src", embedUrl);
    // $('#youtube-modal').on('load', function () {
    //   videoControl("playVideo", '#youtube-modal');
    //   $(".st-Loading").addClass("loaded");
    // });
    var video = document.getElementById('intro-video');
    video.pause();
    $(".st-Loading").addClass("loaded");

    // video.addEventListener('ended', function() {
    //   $(".st-Loading").addClass("loaded");
    // });
  });
};



// ------------------------------------------------------------------------
// bnrToggle
// ------------------------------------------------------------------------
const bnrToggle = () => {
  $(window).on("load", function () {
    let trg = 0;
    let arr = getCookie();
    if (arr['flag'] == 1) {
      $('.st-Nextact').addClass("disabled")
    }
    $(".banner-close").on("click", function () {
      $(".st-Nextact").removeClass("visible");
      setTimeout(function () {
        $('.st-Nextact').addClass("disabled")
        document.cookie = "flag=1; path=/; max-age=86400";
      }, 500);
      trg = 9;
    });
    let visibleHeight = $('.idx-Nextact').offset().top - $('.idx-Nextact').outerHeight();
    gsap.to('.st-Nextact', {
      scrollTrigger: {
        trigger: '.idx-Opening',
        start: 'center center',
        end: () => visibleHeight,
        toggleClass: { targets: ".st-Nextact", className: "visible" },
      }
    });
  });
};


// ------------------------------------------------------------------------
// listTotop
// ------------------------------------------------------------------------
const listTotop = () => {
  $(window).on("load", function () {
    console.log("w");

    let visibleHeight = $('.entrywork').outerHeight() + $('.st-Banner').outerHeight() * 8;
    gsap.to('.list-totop', {
      scrollTrigger: {
        trigger: '.list-anchor',
        start: 'bottom top',
        end: () => visibleHeight,
        toggleClass: { targets: ".list-totop", className: "visible" },
      }
    });
  });
};


// ------------------------------------------------------------------------
// animeScroll
// ------------------------------------------------------------------------
const animeScroll = () => {
  $(window).on("load", function () {
    $(".anim-sc").each(function (i, node) {
      gsap.to(node, {
        scrollTrigger: {
          trigger: node,
          start: 'top bottom-=200',
          toggleClass: { targets: node, className: "animated" },
          once: true
        }
      });
    });
  });
};




// ------------------------------------------------------------------------
// animeLoad
// ------------------------------------------------------------------------
const animeLoad = () => {
  $(window).on("load", function () {
    $(".anim-ld").toggleClass("animated");
  });
};




export {
  preload,
  loading,
  anchorLink,
  topSlider,
  middleSlider,
  toggleNav,
  toggleProf,
  toggleMovie,
  bnrToggle,
  animeScroll,
  animeLoad,
  listTotop
}



// WEBPACK FOOTER //
// ./src/assets/js/include/module.js